// ABOUTME: Reusable section heading with optional info tooltip and subtitle.
// ABOUTME: Used by DeliveryWindowForm and OperationalHoursForm for consistent section headers.
import {Icon} from '@hm/fundamental'
import {CountryConfigsTooltip} from './CountryConfigsTooltip'
import {mdiInformationOutline} from '@mdi/js'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'

interface SectionTitleProps {
  titleKey: string
  tooltipKey?: string
  subtitle?: string
}

export const SectionTitle: React.FC<SectionTitleProps> = ({titleKey, tooltipKey, subtitle}) => {
  const {t} = useTranslation()
  return (
    <div>
      <div className="flex gap-0.5 items-center">
        <span className="text-lg font-semibold leading-6 text-foreground">{t(titleKey)}</span>
        {tooltipKey && (
          <CountryConfigsTooltip content={t(tooltipKey)} delayMs={300}>
            <span className="text-foreground flex items-center cursor-default">
              <Icon path={mdiInformationOutline} size="regular" />
            </span>
          </CountryConfigsTooltip>
        )}
      </div>
      {subtitle && <span className="text-sm text-foreground_faded">{t(subtitle)}</span>}
    </div>
  )
}
